






















































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'

const CorHexRegex = /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/

const EstiloPadrao = () => ({
  corCabecalho: '#2196F3',
  corBarraSecao: '#EEEEEE',
  corBarraTotais: '#2196F3',
  fonte: '',
  tamanhoTexto: 11,
  negrito: false,
  alinhamento: 'Centro',
  espacamento: 10,
  larguraBlocoValor: 120,
})

const TituloPadraoExtrato = 'Relatório de Repasse de Prestadores'

// Padrões iguais ao PDF do extrato sem configuração (modelo do protótipo): salvar sem mexer não muda o relatório.
const EstiloPadraoExtrato = () => ({
  fonte: '',
  tamanhoTexto: 8,
  orientacao: 'Paisagem',
  tituloRelatorio: '',
  corCabecalhoTabela: '#FFFFFF',
  corTextoCabecalhoTabela: '#000000',
  corLinhaSubtotal: '#EEEEEE',
  corLinhaTotal: '#FFFFFF',
  linhasZebradas: false,
  corZebrado: '#F5F5F5',
  posicaoSubtotal: 'AposMedico',
  exibirConta: true,
  exibirAtendimento: true,
  exibirCp: true,
  exibirValorFilme: true,
  exibirObservacao: true,
})

const ColunasPreviewExtrato: any[] = [
  { titulo: 'Conta', campo: 'conta', opcional: 'exibirConta' },
  { titulo: 'Atendimento', campo: 'atendimento', opcional: 'exibirAtendimento' },
  { titulo: 'Paciente', campo: 'paciente' },
  { titulo: 'CP', campo: 'cp', opcional: 'exibirCp', centro: true },
  { titulo: 'Médico Executor', campo: 'medico' },
  { titulo: 'Convênio', campo: 'convenio' },
  { titulo: 'Data', campo: 'data', centro: true },
  { titulo: 'Quant.', campo: 'quantidade', centro: true },
  { titulo: 'Cod. Proc.', campo: 'codigo' },
  { titulo: 'Procedimento', campo: 'procedimento' },
  { titulo: 'Observação', campo: 'observacao', opcional: 'exibirObservacao' },
  { titulo: 'Vl. Repasse', campo: 'valorRepasse', valor: true },
  { titulo: 'Vl. Filme Repasse', campo: 'valorFilme', opcional: 'exibirValorFilme', valor: true },
  { titulo: 'Vl. Total', campo: 'valorTotal', valor: true },
]

const LinhasPreviewExtrato: any[] = [
  {
    conta: '3410935',
    atendimento: '23380508',
    paciente: 'PACIENTE A',
    cp: 'N',
    medico: 'MÉDICO EXEMPLO',
    convenio: 'CONVÊNIO A',
    data: '01/09/2026',
    quantidade: '1',
    codigo: '10101012',
    procedimento: 'CONSULTA EM CONSULTÓRIO',
    observacao: '',
    valorRepasse: 150,
    valorFilme: 0,
  },
  {
    conta: '3410935',
    atendimento: '23380508',
    paciente: 'PACIENTE A',
    cp: 'N',
    medico: 'MÉDICO EXEMPLO',
    convenio: 'CONVÊNIO A',
    data: '03/09/2026',
    quantidade: '1',
    codigo: '40103137',
    procedimento: 'CAMPIMETRIA COMPUTADORIZADA',
    observacao: '',
    valorRepasse: 35.7,
    valorFilme: 0,
  },
  {
    conta: '-',
    atendimento: '-',
    paciente: '-',
    cp: 'N',
    medico: 'MÉDICO EXEMPLO',
    convenio: 'CONVÊNIO B',
    data: '30/09/2026',
    quantidade: '1',
    codigo: '-',
    procedimento: 'Lançamento manual',
    observacao: 'Desconto taxa administrativa',
    valorRepasse: -20,
    valorFilme: 0,
  },
].map(linha => ({ ...linha, valorTotal: linha.valorRepasse + linha.valorFilme }))

const formatarValor = (valor: number) => valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

// Mesma regra do PDF: o texto sobre uma faixa colorida acompanha a luminância do fundo.
const corTextoPara = (corFundo: string) => {
  let hex = (corFundo || '').replace('#', '')
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(c => c + c)
      .join('')
  }
  if (hex.length !== 6) return '#000000'
  const vermelho = parseInt(hex.substr(0, 2), 16)
  const verde = parseInt(hex.substr(2, 2), 16)
  const azul = parseInt(hex.substr(4, 2), 16)
  const luminancia = (0.299 * vermelho + 0.587 * verde + 0.114 * azul) / 255
  return luminancia > 0.6 ? '#000000' : '#FFFFFF'
}

const mensagemErro = (request: any) => {
  const detalhe = request.message || (request.errors && request.errors.length && request.errors[0].message)
  return detalhe ? `${detalhe} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`
}

@Component
export default class ViewFinanceiroRelatorioConfiguracao extends Vue {
  relatorioId: string = ''
  estilo: any = EstiloPadrao()
  salvando: boolean = false
  relatorioSelecionado: any = null
  arquivoLayoutSelecionado: any[] = []
  relatorios: any[] = []

  regrasCor = [(v: any) => !v || CorHexRegex.test(v) || 'Cor inválida, use o formato #RRGGBB']

  regrasTitulo = [(v: any) => !v || String(v).length <= 80 || 'Use no máximo 80 caracteres']

  regrasTamanhoExtrato = [(v: any) => (v >= 6 && v <= 14) || 'Use um tamanho entre 6 e 14']

  // Mesmas faixas aceitas pela API e pelo gerador do PDF sintético.
  regrasTamanhoSintetico = [(v: any) => (v !== '' && v >= 6 && v <= 14) || 'Use um tamanho entre 6 e 14']

  regrasEspacamento = [(v: any) => (v !== '' && v >= 0 && v <= 20) || 'Use um espaçamento entre 0 e 20']

  regrasLarguraBlocoValor = [(v: any) => (v !== '' && v >= 60 && v <= 300) || 'Use uma largura entre 60 e 300']

  // Mesmo modelo do PDF validado pela cliente: créditos, débitos e total a receber.
  get blocosPreviewSintetico() {
    return [
      {
        titulo: 'Créditos',
        total: 'R$ 1.234,56',
        linhas: [
          { descricao: 'CONVÊNIOS', valor: 'R$ 1.234,56' },
          { descricao: 'OUTROS CRÉDITOS (CRÉDITO MANUAL)', valor: 'R$ -' },
        ],
      },
      {
        titulo: 'Débitos',
        total: '-R$ 60,00',
        linhas: [
          { descricao: 'TAXA UNIMED', valor: '-R$ 60,00' },
          { descricao: 'OUTROS DÉBITOS (DÉBITO MANUAL)', valor: 'R$ -' },
        ],
      },
    ]
  }

  get larguraBlocoValorPreview() {
    const largura = Number(this.estilo.larguraBlocoValor) || 120
    return `${Math.min(Math.max(largura, 60), 300)}px`
  }

  estiloFaixaSintetico(cor: string, padrao: string) {
    const fundo = this.corValidaOuPadrao(cor, padrao)
    return { backgroundColor: fundo, color: corTextoPara(fundo), padding: this.espacamentoPreview }
  }

  corValidaOuPadrao(valor: string, padrao: string) {
    return CorHexRegex.test(valor || '') ? valor : padrao
  }

  get tamanhoTextoPreview() {
    const tamanho = Number(this.estilo.tamanhoTexto) || 11
    return Math.min(Math.max(tamanho, 6), 14)
  }

  get estiloPreviewBase() {
    return {
      fontFamily: this.estilo.fonte || undefined,
      fontSize: `${this.tamanhoTextoPreview}px`,
    }
  }

  get alinhamentoCss() {
    const mapa: any = { Esquerda: 'left', Centro: 'center', Direita: 'right' }
    return mapa[this.estilo.alinhamento] || 'center'
  }

  get espacamentoPreview() {
    const espacamento = Number(this.estilo.espacamento)
    return `${Number.isNaN(espacamento) ? 10 : Math.min(Math.max(espacamento, 0), 20)}px`
  }

  get tamanhoPreviewTitulo() {
    return `${this.tamanhoTextoPreview + 3}px`
  }

  ehPdf(relatorio: any) {
    return !!relatorio && relatorio.formato === 'Pdf'
  }

  get ehRelatorioSintetico() {
    return !!this.relatorioSelecionado && this.relatorioSelecionado.estiloConfiguravel === true && this.relatorioSelecionado.layoutPdf !== 'Extrato'
  }

  get ehLayoutExtrato() {
    return !!this.relatorioSelecionado && this.relatorioSelecionado.estiloConfiguravel === true && this.relatorioSelecionado.layoutPdf === 'Extrato'
  }

  get ehEstiloConfiguravel() {
    return this.ehRelatorioSintetico || this.ehLayoutExtrato
  }

  get tituloPadraoExtrato() {
    return TituloPadraoExtrato
  }

  get orientacoesDisponiveis() {
    return [
      { key: 'Paisagem', display: 'Paisagem (como o protótipo)' },
      { key: 'Retrato', display: 'Retrato' },
    ]
  }

  get posicoesSubtotalDisponiveis() {
    return [
      { key: 'AposMedico', display: 'Após as linhas de cada médico' },
      { key: 'FinalRelatorio', display: 'No final do relatório' },
    ]
  }

  get colunasOpcionaisExtrato() {
    return [
      { chave: 'exibirConta', rotulo: 'Conta' },
      { chave: 'exibirAtendimento', rotulo: 'Atendimento' },
      { chave: 'exibirCp', rotulo: 'CP' },
      { chave: 'exibirObservacao', rotulo: 'Observação' },
      { chave: 'exibirValorFilme', rotulo: 'Vl. Filme Repasse' },
    ]
  }

  get colunasPreviewExtrato() {
    return ColunasPreviewExtrato.filter(coluna => !coluna.opcional || this.estilo[coluna.opcional] !== false)
  }

  get colunasValorPreviewExtrato() {
    return this.colunasPreviewExtrato.filter(coluna => coluna.valor)
  }

  get colunasTextoPreviewExtrato() {
    return this.colunasPreviewExtrato.length - this.colunasValorPreviewExtrato.length
  }

  get linhasPreviewExtrato() {
    return LinhasPreviewExtrato.map(linha => ({
      ...linha,
      valorRepasse: formatarValor(linha.valorRepasse),
      valorFilme: formatarValor(linha.valorFilme),
      valorTotal: formatarValor(linha.valorTotal),
    }))
  }

  totalPreviewExtrato(campo: string) {
    return formatarValor(LinhasPreviewExtrato.reduce((total: number, linha: any) => total + linha[campo], 0))
  }

  get estiloPreviewExtrato() {
    const tamanho = Number(this.estilo.tamanhoTexto) || 8
    return {
      fontFamily: this.estilo.fonte || undefined,
      fontSize: `${Math.min(Math.max(tamanho, 6), 14) + 3}px`,
    }
  }

  get estiloCabecalhoTabelaExtrato() {
    return {
      backgroundColor: this.corValidaOuPadrao(this.estilo.corCabecalhoTabela, '#FFFFFF'),
      color: this.corValidaOuPadrao(this.estilo.corTextoCabecalhoTabela, '#000000'),
    }
  }

  estiloFaixaExtrato(cor: string, padrao: string) {
    const fundo = this.corValidaOuPadrao(cor, padrao)
    return { backgroundColor: fundo, color: corTextoPara(fundo) }
  }

  estiloLinhaExtrato(indice: number) {
    return this.estilo.linhasZebradas && indice % 2 === 1
      ? { backgroundColor: this.corValidaOuPadrao(this.estilo.corZebrado, '#F5F5F5') }
      : { backgroundColor: '#FFFFFF' }
  }

  get ehRelatorioPdfSemEstilo() {
    return !!this.relatorioSelecionado && this.ehPdf(this.relatorioSelecionado) && !this.ehEstiloConfiguravel
  }

  get fontesDisponiveis() {
    return ['Lato', 'Calibri', 'Arial', 'Times New Roman', 'Courier New', 'Verdana']
  }

  get alinhamentosDisponiveis() {
    return [
      { key: 'Esquerda', display: 'Esquerda' },
      { key: 'Centro', display: 'Centro' },
      { key: 'Direita', display: 'Direita' },
    ]
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get relatoriosAll() {
    return this.relatorios
  }

  async carregarRelatorios() {
    const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatoriosConfiguracaoEstilo()

    if (!request.success) {
      this.relatorios = []
      EventBus.$emit('setSnackbar', { show: true, text: mensagemErro(request), icon: 'warning', color: '#C62828' })
      return
    }

    const dados: any = request.data
    this.relatorios = Array.isArray(dados) ? dados : ((dados && dados.itens) || [])
  }

  onChangeRelatorio(relatorioId: string) {
    this.relatorioSelecionado = this.relatoriosAll.find((r: any) => r.id === relatorioId) || null
    this.arquivoLayoutSelecionado = []
    this.estilo = EstiloPadrao()

    if (!this.relatorioSelecionado || !this.ehEstiloConfiguravel) return

    let configuracaoSalva: any = {}
    try {
      configuracaoSalva = JSON.parse(this.relatorioSelecionado.configuracaoEstilo || '{}')
    } catch {
      configuracaoSalva = {}
    }

    if (this.ehLayoutExtrato) {
      // Só as chaves do layout do extrato: configurações antigas de outro layout não vão para o JSON salvo.
      const padrao: any = EstiloPadraoExtrato()
      Object.keys(padrao).forEach((chave) => {
        if (configuracaoSalva[chave] !== undefined && configuracaoSalva[chave] !== null) padrao[chave] = configuracaoSalva[chave]
      })
      this.estilo = padrao
      return
    }

    this.estilo = { ...EstiloPadrao(), ...configuracaoSalva }
  }

  async salvar() {
    if (this.ehEstiloConfiguravel) {
      await this.salvarEstilo()
    } else if (!this.ehRelatorioPdfSemEstilo) {
      await this.salvarArquivoLayout()
    }
  }

  async salvarEstilo() {
    if (!(this.$refs.formEstilo as any).validate()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Revise os campos destacados.', icon: 'warning', color: '#C62828' })
      return
    }

    this.salvando = true

    const configuracaoEstilo = JSON.stringify(this.estilo)
    const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateRelatorioConfiguracaoEstilo(this.relatorioSelecionado.id, configuracaoEstilo)

    if (request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Configuração salva com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.relatorioSelecionado.configuracaoEstilo = configuracaoEstilo
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: mensagemErro(request), icon: 'warning', color: '#C62828' })
    }

    this.salvando = false
  }

  async salvarArquivoLayout() {
    if (!this.arquivoLayoutSelecionado.length) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Selecione um arquivo .xlsx antes de salvar.', icon: 'warning', color: '#C62828' })
      return
    }

    this.salvando = true

    const arquivo = this.arquivoLayoutSelecionado[0]
    const form = new FormData()
    form.append('arquivo', arquivo.file || arquivo)

    const request = await this.getFinanceiroStore.updateRelatorioArquivoLayout({ relatorioId: this.relatorioSelecionado.id, form })

    if (request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Layout atualizado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.relatorioSelecionado.nomeArquivoLayout = arquivo.name
      this.arquivoLayoutSelecionado = []
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.salvando = false
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    await this.carregarRelatorios()
    EventBus.$emit('clearLoadingRequest')
  }
}
